import { create } from 'zustand';

interface ProfileUIState {
  previewMode: boolean;
  isMobileView: boolean;

  setPreviewMode: (val: boolean) => void;
  togglePreviewMode: () => void;

  setMobileView: (val: boolean) => void;
  detectViewMode: () => void;
}

export const useProfileUIStore = create<ProfileUIState>((set, get) => ({
  previewMode: false,
  isMobileView: false,

  setPreviewMode: (val) => set({ previewMode: val }),
  togglePreviewMode: () =>
    set((state) => ({ previewMode: !state.previewMode })),

  setMobileView: (val) => set({ isMobileView: val }),

  detectViewMode: () => {
    const isMobile = window.innerWidth <= 768;
    set({ isMobileView: isMobile });
  },
}));
